import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FormattedMessage } from "react-intl";
import CreateStudentInClassForm from "../Forms/CreateStudentInClassForm";

export default function CreateStudentInClass(props) {
  return (
    <Modal
      size="lg"
      isOpen={props.addNewStudentToClassModal}
      toggle={props.toggle}
    >
      <ModalHeader>
        <FormattedMessage id="CreateAndAddStudentToClass" />
      </ModalHeader>
      <ModalBody>
        <CreateStudentInClassForm
          toggle={props.toggle}
          toggleAndAddLicense={props.toggleAndAddLicense}
          classId={props.classId}
          purchaserTeacher={props.purchaserTeacher}
        />
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
}
